import styled from 'styled-components';
import tw from 'twin.macro';
import { palette } from './palette';

export const CardStyle = {
  boxShadow: 'none',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
    transform: 'translateY(-5px)',
  },
};

export const MainTeamContainer = styled.div`
  ${tw`mt-[120px] min-h-screen mb-[30px] lg:mb-[50px]`}
`;

export const TitleContMain = styled.div`
  ${tw`flex justify-center items-center mt-[-20px] `}
`;

export const TeamsDesc = styled.p`
  ${tw`font-thin mt-5 mx-5 lg:mx-10 2xl:text-xl xl:text-xl text-justify leading-7 lg:leading-8 
  text-base lg:text-lg tracking-wide max-w-6xl`}
  color: ${palette.black};
`;

export const GridContainer = styled.div`
  ${tw` px-4 lg:px-8 xl:px-12`}
`;

export const TitleDash = styled.hr`
  ${tw`h-[2px] lg:h-[3px] w-[120px] md:w-[200px] lg:w-[300px] rounded-lg mb-5`}
  background:${palette.primary}
`;

export const ContainerB = styled.div`
  ${tw`flex justify-center items-center flex-col`}
`;
